/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 云剧院主题配置
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cloundtheater.RenvationDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cloundtheater/theme`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
